var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstanew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#df477b;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 22,
    cy: 22,
    r: 22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.75,14.24a2,2,0,0,0-1.52-.64H15.74a2,2,0,0,0-1.52.64,2.09,2.09,0,0,0-.64,1.52V28.24a2.09,2.09,0,0,0,.64,1.52,2,2,0,0,0,1.52.64H28.23a2,2,0,0,0,1.52-.64,2.08,2.08,0,0,0,.63-1.52V15.76A2.08,2.08,0,0,0,29.75,14.24ZM19.62,19.65a3.46,3.46,0,0,1,4.76,0,3.2,3.2,0,0,1,0,4.63,3.43,3.43,0,0,1-4.76,0,3.2,3.2,0,0,1,0-4.63Zm8.86,8.15a.63.63,0,0,1-.2.47.64.64,0,0,1-.47.19H16.12a.61.61,0,0,1-.47-.19.63.63,0,0,1-.19-.47V20.71H17a4.59,4.59,0,0,0-.22,1.43,4.79,4.79,0,0,0,1.53,3.58A5.1,5.1,0,0,0,22,27.21a5.29,5.29,0,0,0,2.63-.68,5,5,0,0,0,1.9-1.85,4.79,4.79,0,0,0,.7-2.54A4.59,4.59,0,0,0,27,20.71h1.48V27.8Zm0-9.77a.73.73,0,0,1-.22.54.75.75,0,0,1-.54.21h-1.9a.72.72,0,0,1-.53-.21.73.73,0,0,1-.22-.54v-1.8a.77.77,0,0,1,.75-.76h1.9a.73.73,0,0,1,.54.23.71.71,0,0,1,.22.53Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstanew);
export default __webpack_public_path__ + "static/media/instanew.8c2c579dff682d9d83d81639e42d32fb.svg";
export { ForwardRef as ReactComponent };